import { render, staticRenderFns } from "./ConfigurazioneContabilitaTipoSoggettoListPage.vue?vue&type=template&id=78fd2496"
import script from "./ConfigurazioneContabilitaTipoSoggettoListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaTipoSoggettoListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports